import React from "react";
import "./ProgressBar.css";

const ProgressBar = (props) => {
  const { total, userProgress = [], label, darkMode } = props;

  return (
    <div className={`progress-container-web ${darkMode ? "dark" : "light"}`} >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {label && <p className="progress-label-web">{label}</p>}
        <p className="progress-text-web">
          {userProgress.length}/{total} Attempted
        </p>
      </div>

      <div className="progress-bar-web progress-bar-segmented-web">
        {userProgress.map((item, idx) => {
          const isCorrect = item.is_correct === 1;
          const segmentWidth = `${100 / total}%`;
          return (
            <div
              key={idx}
              className={`progress-segment-web ${
                isCorrect ? "correct" : "wrong"
              }`}
              style={{ width: segmentWidth }}
            />
          );
        })}
        {Array.from({ length: total - userProgress.length }).map((_, idx) => (
          <div
            key={`empty-${idx}`}
            className="progress-segment-web empty"
            style={{ width: `${100 / total}%` }}
          />
        ))}
      </div>
    </div>
  );
};

export default ProgressBar;
